// LAYOUT
import '../layout.js'; 

// MARGIN TOP BANNER PAGE
const nav = document.querySelector('.navbar');
const pageBanner = document.querySelector('.page-banner');
if (window.innerWidth > 991) {
    pageBanner.style.marginTop = (nav.offsetHeight - 5) + "px";
} else {
    pageBanner.style.marginTop = nav.offsetHeight + "px";
}